import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Landing from "./pages/Landing";
import "./App.css";

const App: React.FC = () => {
  return (
    <Router>
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </main>
    </Router>
  );
};

export default App;
